module.exports = __webpack_public_path__ + "static/media/bastei-bridge.1807eb58.jpg";